import { connect } from 'react-redux';
import ClientInfo from './ClientInfo';

import {
    setClientInfoIsOpen,
    setClientInfoSelectedState,
    setCompanyName,
    setClientInfoStreet,
    setClientInfoStreet2,
    setClientInfoZip,
    setClientInfoCity,
    setCountry,
} from './actions';

import { updateClientStatus } from '../actions';


const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    isOpen: state.clientInfoUI.isOpen,
    selectedState: state.clientInfoUI.selectedState,
    companyName: state.clientInfoUI.companyName,
    street: state.clientInfoUI.street,
    street2: state.clientInfoUI.street2,
    country: state.clientInfoUI.country,
    Zip: state.clientInfoUI.Zip,
    city: state.clientInfoUI.city,
    firstName: state.contactUI.firstName,
    phone: state.contactUI.phone,
    position: state.contactUI.position,
    email: state.contactUI.email,
    loading: state.settings.loading,
    setClientInfoIsOpen,
    setClientInfoSelectedState,
    setCompanyName,
    setClientInfoStreet,
    setClientInfoZip,
    setClientInfoCity,
    updateClientStatus,
    setClientInfoStreet2,
});

const combinedActions = {
    setClientInfoIsOpen,
    setClientInfoSelectedState,
    setCompanyName,
    setClientInfoStreet,
    setClientInfoZip,
    setClientInfoCity,
    updateClientStatus,
    setCountry,
    setClientInfoStreet2,
};

export default connect(mapStateToProps, combinedActions)(ClientInfo);



// WEBPACK FOOTER //
// ./src/containers/AddClient/ClientInfo/index.js